const { Core, Events, DOMEvents, Utils } = Global;
const { $state } = Utils;

customElements.define('cart-drawer-custom-popup', class extends Core {
    elements = {
        modal: 'modal-container'
    }

    render() {
        this.$({ change: this._publishChange });
        this.$('modal', {'modal-close': this._handleClose } );
    }

    _publishChange(e) {
        e.stopPropagation();
        e.preventDefault();
        this.$('modal').close();
    }
    
    _handleClose(e) {
        e.stopPropagation();
    }
})